import React, { useEffect, useState } from 'react'
import { Modal } from 'antd'
import { BudgetPaymentTransactionModal } from '../BudgetPaymentTransactionModal'
import { OtherTransactionModal } from '../OtherTransactionModal'
import { TransferTransactionModal } from '../TransferTransactionModal'
import { InvestmentTransactionModal } from '../InvestmentTransactionModal'
import { DividendTransactionModal } from '../DividendTransactionModal'
import { allWalletMounted, walletAllowedListMounted } from './model'
import { Currency } from '../../../../../views/widgets/walletCard/types'
import { TransactionModalState } from '../TransactionsDetails/types'
import { CommissionPaymentTransactionModal } from '../CommissionPaymentTransactionModal'
import { ChargebackTransactionModal } from '../ChargebackTransactionModal'
import { ModalType } from '../types'
import styles from './styles.module.css'
import { CreateDebtModal } from 'src/pages/finSystem/debt/create'
import {
  useDebtListGate,
  useModalCreateDebt,
} from 'src/pages/finSystem/debt/hook'

type SelectedType = keyof Omit<TransactionModalState, 'transaction' | 'wallet'>

type Props = {
  isOpen: boolean
  currenciesFromWallet: string[]
  allCurrencies: Currency[]
  onClose: () => void
  type: ModalType
}

const TYPE_OPTIONS: Array<{ key: SelectedType; label: string }> = [
  { key: 'createTransferModal', label: 'From one payment system to another' },
  { key: 'createBudgetPaymentModal', label: 'Budget payment' },
  { key: 'createInvestmentModal', label: 'Investments and Dividends LP' },
  { key: 'createDividendModal', label: 'Dividends and Investments LP' },
  { key: 'createOtherModal', label: 'Other type' },
  { key: 'createCommissionPaymentModal', label: 'Commission' },
  { key: 'createChargebackModal', label: 'Chargeback' },
  { key: 'createDebtModal', label: 'Debt transaction' },
]

export const GeneralTransactionModal: React.FC<Props> = ({
  isOpen,
  allCurrencies,
  onClose,
  type,
}) => {
  const { isOpenModalCreateDebt, setIsOpenModalCreateDebt } =
    useModalCreateDebt()
  const [selectedType, setSelectedType] = useState<SelectedType | null>(null)

  useEffect(() => {
    if (isOpen) {
      allWalletMounted()
      walletAllowedListMounted()
    } else {
      setSelectedType(null)
    }
  }, [isOpen])

  const handleClose = () => {
    setSelectedType(null)
    onClose()
  }

  const handleBackToChooser = () => {
    setSelectedType(null)
  }

  useDebtListGate()

  return (
    <>
      {selectedType === null && (
        <Modal
          open={isOpen}
          onCancel={onClose}
          title={null}
          footer={null}
          width={620}
          destroyOnHidden
          className={styles.modal}
        >
          <div className={styles.body}>
            <h2 className={styles.title}>Choose type of transaction:</h2>
            <div className={styles.options}>
              {TYPE_OPTIONS.map((opt) => (
                <button
                  type="button"
                  key={opt.key}
                  className={styles.option}
                  onClick={() => {
                    setSelectedType(opt.key)
                    if (opt.key === 'createDebtModal') {
                      setIsOpenModalCreateDebt(true)
                    }
                  }}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>
        </Modal>
      )}
      {selectedType === 'createTransferModal' && (
        <TransferTransactionModal
          isOpen
          onClose={handleClose}
          onCancel={handleBackToChooser}
          type={type}
        />
      )}
      {selectedType === 'createBudgetPaymentModal' && (
        <BudgetPaymentTransactionModal
          isOpen
          onClose={handleClose}
          onCancel={handleBackToChooser}
          type={type}
        />
      )}
      {selectedType === 'createOtherModal' && (
        <OtherTransactionModal
          isOpen
          onClose={handleClose}
          onCancel={handleBackToChooser}
          type={type}
        />
      )}
      {selectedType === 'createInvestmentModal' && (
        <InvestmentTransactionModal
          isOpen
          allCurrencies={allCurrencies}
          onClose={handleClose}
          onCancel={handleBackToChooser}
          type={type}
        />
      )}
      {selectedType === 'createDividendModal' && (
        <DividendTransactionModal
          isOpen
          allCurrencies={allCurrencies}
          onClose={handleClose}
          onCancel={handleBackToChooser}
          type={type}
        />
      )}
      {selectedType === 'createCommissionPaymentModal' && (
        <CommissionPaymentTransactionModal
          isOpen
          onClose={handleClose}
          onCancel={handleBackToChooser}
          type={type}
        />
      )}
      {selectedType === 'createChargebackModal' && (
        <ChargebackTransactionModal
          isOpen
          onClose={handleClose}
          onCancel={handleBackToChooser}
          type={type}
        />
      )}
      <CreateDebtModal
        isOpen={isOpenModalCreateDebt}
        type={type}
        onClose={() => {
          setIsOpenModalCreateDebt(false)
          setSelectedType(null)
        }}
      />
    </>
  )
}
